import { ListItem, Shadows } from "@mui/material";
import { styled } from "@mui/system";
import { LinkProps } from "react-router-dom";

interface MainListItemProps {
    component?: React.ForwardRefExoticComponent<LinkProps & React.RefAttributes<HTMLAnchorElement>>;
    end?: boolean;
    to?: string;
}

export const MainListItem = styled(ListItem, {
    name: 'MuiMainListItem',
})<MainListItemProps>(({theme}) => ({
    boxShadow: (theme.shadows as Shadows)[1],
    backgroundColor: theme.palette.background.paper,
    marginBottom: '0.5rem',
    borderRadius: '0.5rem',
    overflow: 'hidden',

    '& .MuiListItemButton-root': {
        padding: '1rem',
        alignItems: 'flex-start',

        '&.Mui-selected': {
            backgroundColor: 'transparent',
            borderLeft: 4,
            borderStyle: 'solid',
            borderColor: theme.palette.info.main,
        },
        '&:hover': {
            backgroundColor: theme.palette.background.default,
        },
        '&.Mui-selected:hover': {
            backgroundColor: theme.palette.background.default,
        },
    },

    '& .MuiListItemText-root': {
        margin: 0,
        padding: 0,
    },

    '& .MuiListItemAvatar-root': {
        minWidth: '24px',
        margin: 0,
        marginRight: '0.75rem',

        // '& .MuiAvatar-root': {
        //     width: 24,
        //     height: 24,
        // }
    },
}));